export { default } from "./multipleInsurancesSelector";
